import { ACL_INITIAL_STATE, useGroupsAclStore } from './groupsAclStore'
import { GROUPS_INITIAL_STATE, useGroupsStore } from './groupsStore'
import { USERS_GROUPS_INITIAL_STATE, useUsersGroupsStore } from './usersGroupsStore'
import { USERS_INITIAL_STATE, useUsersStore } from './usersStore'

export const resetAllUserManagementStores = () => {
  useGroupsStore.setState({
    ...GROUPS_INITIAL_STATE,
  })

  useUsersStore.setState({
    ...USERS_INITIAL_STATE,
  })

  useGroupsAclStore.setState({
    ...ACL_INITIAL_STATE,
  })

  useUsersGroupsStore.setState({
    ...USERS_GROUPS_INITIAL_STATE,
  })
}
